import { BasketAddressFormModel } from '../model/basket-address-form.model';

export class SaveBasketAddressFormAction {
  static type = '[BASKET] Save Address form';

  constructor(readonly form: BasketAddressFormModel) {}
}
